// .env
export const APP_NAME = process.env.REACT_APP_APP_NAME;
export const APP_HOST = process.env.REACT_APP_APP_HOST;
export const API_HOST = process.env.REACT_APP_API_HOST;
